import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';

import { HealPromoParams, HealPromoResponse, healPromo } from '~/services/PromoService';

export function usePromoHeal() {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const brand = useSelector((state: App.State) => state.tenant.brand);

  const healPromoMutation = useMutation({
    mutationFn: async (params: Omit<HealPromoParams, 'brand'>) => {
      return await healPromo({
        ...params,
        brand: brand || 'luxuryescapes',
      });
    },
    onSuccess: (response: HealPromoResponse) => {
      enqueueSnackbar(response.message, { variant: 'success' });

      // Invalidate relevant queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['promos'] });
      queryClient.invalidateQueries({ queryKey: ['promo'] });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error healing promo: ${error.message}`, { variant: 'error' });
    },
  });

  return {
    healPromo: healPromoMutation.mutate,
    healPromoAsync: healPromoMutation.mutateAsync,
    isHealing: healPromoMutation.isPending,
    error: healPromoMutation.error,
  };
}
